import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 2070D6C6-EC09-4507-BE0A-07BFFFAF6DFB
 * name check-bold
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-bold.svg
 * tags
 */
export const CheckBoldIcon = createSvgIcon(<><path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" /></>, 'CheckBoldIcon');
export default CheckBoldIcon